<template>
  <drag-dialog
    :visible.sync="visible"
    :title="auditTitle"
    v-bind="$attrs"
    v-on="$listeners"
    :width="hasSlot ? '1000px' : '800px'"
    :height="hasSlot ? '800px' : '350px'"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <div v-if="hasSlot" class="detail-wrap">
      <!-- 被审核信息 插槽 -->
      <slot></slot>
    </div>

    <el-form v-loading="detailLoading" :model="editForm" ref="editForm" :rules="rules" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="审核是否通过" prop="state">
            <el-radio-group v-model="editForm.state">
              <template v-if="auditType === 'reportAudit'">
                <el-radio :label="8">通过</el-radio>
                <el-radio :label="-8">驳回到实验员</el-radio>
                <el-radio :label="-2">驳回到接样管理</el-radio>
              </template>
              <template v-else-if="auditType === 'reportApprove'">
                <el-radio :label="9">通过</el-radio>
                <el-radio :label="-9">驳回到实验员</el-radio>
                <el-radio :label="-2">驳回到接样管理</el-radio>
              </template>
              <template v-else-if="auditType === 'meterialReportAudit' || auditType === 'qualityReportAudit'">
                <el-radio :label="8">通过</el-radio>
                <el-radio :label="-8">驳回</el-radio>
              </template>
              <template v-else-if="auditType === 'meterialReportApprove' || auditType === 'qualityReportApprove'">
                <el-radio :label="9">通过</el-radio>
                <el-radio :label="-9">驳回</el-radio>
              </template>
              <template v-else>
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="-1">驳回</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col
          v-if="(auditType === 'reportAudit' && editForm.state == -8) || (auditType === 'reportApprove' && editForm.state == -9)"
          :span="24"
        >
          <el-form-item label="驳回的实验员" prop="testedBys">
            <el-checkbox-group v-model="editForm.testedBys" multiple>
              <el-checkbox v-for="item in testedByOpetions" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="审核意见" prop="reason">
            <el-input type="textarea" v-model="editForm.reason" placeholder="驳回时必填" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import * as apis from '@/api/audit';
import { getFlowDeliver } from '@/api/flow';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // reportAudit 报告审核；reportApprove 报告批准; meterialReportAudit 设备材料检测报告审核; meterialReportApprove 设备材料检测报告批准
    // qualityReportAudit  工程质量检测审核；qualityReportApprove 工程质量检测批准
    auditType: {
      type: String,
      default: ''
    },
    auditTitle: {
      type: String,
      default: ''
    },
    auditId: {
      type: [Number, String],
      default: null
    },
    auditLoading: {
      type: Boolean,
      default: false
    },
    // 是否有审核详情插槽
    hasSlot: {
      type: Boolean,
      default: true
    },
    api: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    var validateReason = (rule, value, callback) => {
      const passStateMap = {
        reportAudit: 8,
        reportApprove: 9,
        meterialReportAudit: 8,
        meterialReportApprove: 9,
        qualityReportAudit: 8,
        qualityReportApprove: 9
      };
      const passState = passStateMap[this.auditType] || 1;

      if (this.editForm.state !== passState && !value) {
        callback(new Error('驳回时意见必填'));
      } else {
        callback();
      }
    };
    return {
      detailData: {},
      detailLoading: false,
      editForm: {
        state: 1,
        testedBys: [],
        userIds: ''
      },
      rules: {
        state: [{ required: true, message: '请选择审核状态', trigger: 'change' }],
        reason: [{ validator: validateReason, trigger: 'blur' }],
        testedBys: [{ required: true, message: '请选择退回的实验员', trigger: 'change' }]
      },
      submitLoading: false,
      testedByOpetions: []
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        if (this.auditType == 'reportAudit' || this.auditType == 'reportApprove') {
          this.getFlowDeliver();
        }
        if (
          this.auditType == 'reportAudit' ||
          this.auditType == 'meterialReportAudit' ||
          this.auditType == 'qualityReportAudit'
        ) {
          this.editForm.state = 8;
        } else if (
          this.auditType == 'reportApprove' ||
          this.auditType == 'meterialReportApprove' ||
          this.auditType == 'qualityReportApprove'
        ) {
          this.editForm.state = 9;
        } else {
          this.editForm.state = 1;
        }
      }
    },
    auditLoading(val) {
      this.submitLoading = val;
    }
  },
  methods: {
    // 获取该流程的检测员信息
    async getFlowDeliver() {
      const { data } = await getFlowDeliver({ entrustmentId: this.auditId });
      const testedByOpetions = data.nodes.map(item => {
        return {
          label: item.testedByName,
          value: item.testedBy
        };
      });
      this.testedByOpetions = testedByOpetions;
      if (this.testedByOpetions.length == 1) {
        this.editForm.testedBys = [this.testedByOpetions[0].value];
      }
    },
    handleSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm(`您确认要提交审核信息？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(async () => {
              this.submitLoading = true;

              try {
                if (this.auditType == 'reportAudit' || this.auditType == 'reportApprove') {
                  const params = {
                    entrustmentId: this.auditId,
                    ...this.editForm,
                    userIds: ''
                  };
                  if (this.editForm.state == -8 || this.editForm.state == -9) {
                    params.userIds = this.editForm.testedBys.join(',');
                  }
                  await apis[this.api](params);
                } else {
                  await apis[this.api]({ id: this.auditId, ...this.editForm });
                }

                this.$message.success('审核成功！');
                this.$emit('refreshData'); // 回调刷新列表数据
                this.$emit('update:visible', false);
              } finally {
                this.submitLoading = false;
              }
            })
            .catch(() => {});
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.detail-wrap {
  height: calc(100% - 200px);
  margin-bottom: 20px;
  overflow: hidden;
  overflow-y: auto;

  .my-table {
    width: 100%;
  }
}
</style>
